import Img from 'react-image';

export default class AfspLogo extends React.Component {
    constructor(props) { super(props); }

    getView(config) {
        var
        { usePathname, logo } = this.props.images,
        { divText, img, div } = config,
        { height, marginTop } = img,
        { top, left, fontSize } = div,
        imgConfig = (function(img) { 
            const { height } = img;
            let data = {
                src: usePathname ? `${window.location.pathname}${logo}` : `${logo}`,
                style: {
                    boxShadow: 'rgba(0, 0, 0, .5) 1px 2px 5px 1px',
                    width: Math.round((height * 1.02)),
                    borderRadius: '100%',
                    height
                }
            };
            if(img.hasOwnProperty('marginTop')) data.style.marginTop = img.marginTop + 'px';
            return data;
        })(img),
        divConfig = (function(div) {
            const { top, left, fontSize } = div;
            return {
                position: 'absolute',
                height: '100%',
                top: `${top}px`,
                left: `${left}px`,
                fontSize: `${fontSize}px`,
                fontFamily: 'Arial',
                color: 'white'
            }
        })(div);

        return (
            <div>
            	<a href="http://www.tsa.gov" target="_blank">
                <Img {...imgConfig} />
                <div style={{...divConfig}}>
                    <div style={{ height: `${divText}px`, textShadow: 'rgb(0, 0, 0) 2px 2px 2px' }}>{'Transportation'}</div>
                    <div style={{ height: `${divText}px`, textShadow: 'rgb(0, 0, 0) 2px 2px 2px' }}>{'Security'}</div>
                    <div style={{ height: `${divText}px`, textShadow: 'rgb(0, 0, 0) 2px 2px 2px' }}>{'Administration'}</div>
                </div>
                </a>
            </div>
        );
    }

    render() {
        switch(this.props.size) {
            case 'na': return (<div></div>);
            case 'lg':
                return this.getView({
                    img: {
                        height: 94
                    },
                    div: {
                        top: 0,
                        left: 114,
                        fontSize: 24
                    },
                    divText: 26
                });
            case 'md':
                return this.getView({
                    img: {
                        height: 80,
                        marginTop: 7
                    },
                    div: {
                        top: -6,
                        left: 94,
                        fontSize: 18
                    },
                    divText: 22
                });
            case 'sm':
                return this.getView({
                    img: {
                        height: 60,
                        marginTop: 6
                    },
                    div: {
                        top: -11,
                        left: 72,
                        fontSize: 13
                    },
                    divText: 16
                });
            case 'xs':
                return this.getView({
                    img: {
                        height: 40,
                        marginTop: -13
                    },
                    div: {
                        top: -17,
                        left: 50,
                        fontSize: 11
                    },
                    divText: 12
                });
        }
    }
}
